import styled from "styled-components";

export const FmsReportNavbarLogo = styled.img`
    height: 2rem;
`;
